import { render, staticRenderFns } from "./SSOLogin.vue?vue&type=template&id=5bedee01"
import script from "./SSOLogin.vue?vue&type=script&lang=js"
export * from "./SSOLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports